export enum Context {
  Colleague,
  Customer
}
